import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  // ModalFooter,
  // Row,
  Col,
  Form,
  FormGroup
  // Label,
  // Input,
  // FormText
} from "reactstrap";
import PropTypes from "prop-types";

import "./style.css";

class SuccessEmailReset extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  backToLogin = () => {
    this.props.toggle("SuccessEmailReset");
    this.props.toggle("login");
  };
  render() {
    const closeBtn = (
      <button
        className="close"
        onClick={() => this.props.toggle("SuccessEmailReset")}
      >
        &times;
      </button>
    );
    return (
      <div>
        <Modal
          className="signup-modal"
          isOpen={this.props.modalOpen}
          toggle={() => this.props.toggle("SuccessEmailReset")}
        >
          <ModalHeader
            toggle={this.toggle}
            close={closeBtn}
            style={{ background: "#FFCD46" }}
          >
            Hay There
          </ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup row>
                <Col sm={12}>
                  <h4 className="text-center mt-5">Password reset email sent! </h4>
                  <h5 className="text-lg text-center"> Please check your inbox.</h5>
                </Col>
              </FormGroup>
              <button
                className="btn-hay-yellow my-4"
                style={{ width: "100%" }}
                onClick={() => this.backToLogin()}
                size="lg"
                block
              >
                Back to Login
              </button>
            </Form>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

SuccessEmailReset.propTypes = {
  modalOpen: PropTypes.bool,
  toggle: PropTypes.func,
  size: PropTypes.string
};

export default SuccessEmailReset;
